/* eslint-disable import/no-cycle */
import React from "react";
import ApplicationSection from "./ApplicationSection";
import DashboardSection from "./DashboardSection";
import InitRegisterDialog from "./InitRegisterDialog";
import OrganizationSection from "./OrganizationSection";
import API from "@/api/serverCall";
import { applicationInfoType, dashboardInfoType } from "types/app";
import { useSelector } from "react-redux";
import { getCompanyInfo } from "@/redux/organization/selector";
import { useTranslation } from "react-i18next";

function Home() {
	// const { t } = useTranslation();
	const [ApplicationInfo, setApplicationInfo] = React.useState<applicationInfoType[]>(
		[],
	);
	const [dashboardInfo, setDashboardInfo] = React.useState<any>();
	const companyInfo = useSelector(getCompanyInfo);
	/* const getApplicationInfo = () => {
		// loading
		try {
			API.GET<applicationInfoType[]>({
				link: `/app`,
			}).then((response) => {
				setApplicationInfo(response.data);
			});
		} catch (error) {
			console.error(error);
		}
	}; */

	const getDasaboardInfo = () => {
		// loading
		try {
			API.GET<dashboardInfoType>({
				link: `/dashboard`,
			}).then((response) => {
				setDashboardInfo(response.data.body);
				const responseAppList = response.data.body.apps;
				const applicationData = responseAppList.map((app) => {
					return {
						id: app.id,
						name: app.name,
						packageAndroid: app.packageAndroid,
						packageIos: app.packageIos,
						companyToken: "",
						appToken: app.appToken,
						nextPaymentAt: app.nextPaymentAt,
						createdAt: app.createdAt,
						isFoodLens: app.isFoodLens,
					};
				});
				setApplicationInfo(applicationData);
			});
		} catch (error) {
			console.error(error);
		}
	};

	React.useEffect(() => {
		// getApplicationInfo();
		getDasaboardInfo();
	}, []);

	return (
		<div>
			{/* <div style={{ marginBottom: "10rem" }}> */}
			<InitRegisterDialog setApplicationInfo={setApplicationInfo} />

			<section style={{ maxWidth: "2000px", margin: "auto" }}>
				<OrganizationSection companyInfo={companyInfo} />
			</section>
			<section style={{ backgroundColor: "#F7F7F7" }}>
				<DashboardSection />
			</section>
			<section style={{ maxWidth: "2000px", margin: "auto" }}>
				<ApplicationSection
					ApplicationInfo={ApplicationInfo}
					setApplicationInfo={setApplicationInfo}
					maxAppCount={companyInfo?.maxApp}
				/>
			</section>
		</div>
	);
}

export default Home;
